import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "w-full" }
const _hoisted_2 = ["id", "type", "value"]
const _hoisted_3 = ["for"]
const _hoisted_4 = {
  key: 0,
  class: "group absolute -right-7 top-3.5 hidden lg:block"
}
const _hoisted_5 = /*#__PURE__*/_createElementVNode("p", { class: "text-xs" }, "Password must be:", -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("ul", { class: "list-disc pl-4 whitespace-nowrap" }, [
  /*#__PURE__*/_createElementVNode("li", null, "minimum of 8 characters"),
  /*#__PURE__*/_createElementVNode("li", null, "at least 1 uppercase"),
  /*#__PURE__*/_createElementVNode("li", null, "at least 1 lowercase"),
  /*#__PURE__*/_createElementVNode("li", null, "at least 1 number"),
  /*#__PURE__*/_createElementVNode("li", null, "at least 1 special character")
], -1)
const _hoisted_7 = [
  _hoisted_5,
  _hoisted_6
]

import { EyeIcon, EyeSlashIcon } from "@heroicons/vue/24/solid";
import { InformationCircleIcon } from "@heroicons/vue/24/outline";
import { ref } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'PasswordInput',
  props: {
    modelValue: {
        default: null,
        required: true,
    },
    id: {
        type: String,
        default: null,
    },
    placeholder: {
        type: String,
        default: null,
    },
    label: {
        type: String,
        default: null,
    },
    helper: {
        type: Boolean,
        default: false,
    },
    error: {
        type: String,
        default: null,
    },
},
  setup(__props) {



const showPassword = ref<boolean>(false);

const inputField = ref()
const focusInput = () => {
    inputField.value.focus();
};

const showHelper = ref<boolean>(false);


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass(["relative rounded-md", __props.label ? 'mt-1' : ''])
    }, [
      _createElementVNode("input", {
        id: __props.id,
        type: showPassword.value ? 'text' : 'password',
        value: __props.modelValue,
        onInput: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('update:modelValue', $event.target.value))),
        ref_key: "inputField",
        ref: inputField,
        class: _normalizeClass(["frm-input block w-full text-sm h-12 disabled:bg-gray-100 focus:outline-none focus:ring-0 bg-zinc-50 px-5 text-gray-800 border-gray-900/[.04] placeholder-gray-20 focus:border-primary-500 rounded-full peer pt-4 pb-1", __props.error ? 'border border-red-300' : '']),
        placeholder: " "
      }, null, 42, _hoisted_2),
      _createElementVNode("label", {
        for: __props.id,
        onClick: _cache[1] || (_cache[1] = ($event: any) => (focusInput())),
        class: "absolute duration-300 transform -translate-y-2.5 top-3.5 left-5 scale-[.60] origin-[0] text-sm text-gray-20 cursor-text peer-focus:text-primary-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-[.60] peer-focus:-translate-y-2.5"
      }, _toDisplayString(__props.placeholder), 9, _hoisted_3),
      _createElementVNode("div", {
        onClick: _cache[2] || (_cache[2] = ($event: any) => (showPassword.value = !showPassword.value)),
        class: "cursor-pointer absolute inset-y-0 right-0 pr-4 flex items-center"
      }, [
        (!showPassword.value)
          ? (_openBlock(), _createBlock(_unref(EyeIcon), {
              key: 0,
              class: "h-5 w-5 text-darkgray-400",
              "aria-hidden": "true"
            }))
          : (_openBlock(), _createBlock(_unref(EyeSlashIcon), {
              key: 1,
              class: "h-5 w-5 text-darkgray-400",
              "aria-hidden": "true"
            }))
      ]),
      (__props.helper)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _createVNode(_unref(InformationCircleIcon), {
              onMouseenter: _cache[3] || (_cache[3] = ($event: any) => (showHelper.value = true)),
              onMouseleave: _cache[4] || (_cache[4] = ($event: any) => (showHelper.value = false)),
              class: "w-5 cursor-pointer text-gray-500"
            }),
            _createElementVNode("div", {
              class: _normalizeClass(["text-xs text-gray-500 mt-1 pl-2 bg-white p-2 border rounded-lg w-fit absolute top-1/2 -translate-y-1/2 left-6 transition duration-300", showHelper.value ? 'opacity-100' : 'opacity-0'])
            }, _hoisted_7, 2)
          ]))
        : _createCommentVNode("", true)
    ], 2),
    (__props.error)
      ? (_openBlock(), _createElementBlock("p", {
          key: 0,
          class: _normalizeClass(["text-[10px] mt-1", __props.error ? 'text-red-600' : 'text-gray-800']),
          id: "email-error"
        }, _toDisplayString(__props.error), 3))
      : _createCommentVNode("", true)
  ]))
}
}

})